export default __webpack_public_path__ + "static/migliori-framework-app-cross-platform-orangeloop-9cad670778cd513df9c35c2218063f58.jpg";